import { atom } from "jotai";
import { IOrderDTO } from "../order";
import { ChannelType, PaginatedResponseType } from "../../globals/types";

// Filter types (moved from Customers.component.tsx to break circular import)
export enum CustomersFilterOptions {
  HAS_ORDERS = 'Has Orders',
  NO_ORDERS = 'No Orders',
}

export interface CustomersFilter {
  orders?: string;
  brand_id?: string;
  query_string?: string;
}

export const customersFilterAtom = atom<CustomersFilter>({
  orders: '',
  brand_id: '',
  query_string: '',
});

export const customersAtom = atom<PaginatedResponseType<ICustomer>>({results: [], count: 0, hasNext: false, hasBefore: false, channel: ChannelType.WALLMATES});
export const customerAtom = atom<ICustomer>({} as ICustomer);
export const customerTypesAtom = atom<ICustomerType[]>([]);
export const customerAddressTypesAtom = atom<ICustomerAddressType[]>([]);
export const customerLoadingAtom = atom<boolean>(false);
export const customersLoadingAtom = atom<boolean>(false);

// Infinite scroll atoms
export const customersAccumulatedAtom = atom<ICustomer[]>([]);
export const customersHasMoreAtom = atom<boolean>(true);
export const customersCurrentPageAtom = atom<number>(0);
export const customersLoadingMoreAtom = atom<boolean>(false);
export const customersCountAtom = atom<number>(0);

// Scroll position & highlight atoms
export const customerListScrollPositionAtom = atom<number>(0);
export const lastViewedCustomerIdAtom = atom<number | null>(null);
export const navigatedFromCustomerDetailAtom = atom<boolean>(false);

export interface ICustomerAddress {
    id?: number,
    address_type: number,
    street_address: string,
    city: string,
    state: string,
    zip: string,
    country: string,
  }
  
  export interface ICustomerMetadata {
    email?: string,
    email_address?: string,
    phone_number?: string,
    phone?: string,
    type: number,
  }
  
  export interface ICustomer {
    id: number
    customer_id: number | string,
    customer_type: number,
    first_name: string,
    last_name: string,
    email_address: string,
    phone_number: string,
    shipping_first_name: string,
    shipping_last_name: string,
    orders_count: number,
    addresses: ICustomerAddress[] | [],
    orders: IOrderDTO[] | [],
    customer_metadata: ICustomerMetadata[] | [],
  }
  
  export interface IUpdateCustomerRequest {
    id: number;
    first_name: string;
    last_name: string;
    shipping_first_name: string;
    shipping_last_name: string;
    email_address: string;
    phone_number: string;
    email: boolean;
    sms: boolean;
    customer_type: number;
  }
  
  export interface IUpdateCustomerAddressRequest {
    id?: number;
    address_type: number;
    street_address: string;
    city: string;
    state: string;
    zip: string;
    country: string;
  }
  
  export interface ICreateCustomerRequest {
    first_name: string,
    last_name: string,
    email_address: string,
    phone_number: string,
    shipping_first_name: string,
    shipping_last_name: string,
    type: number,
  }
  
  export interface IGetCustomersQuery {
    page_count: number;
    page: number;
    filter_by: CustomersFilter;
  }
  
  export interface ICustomerType {
    id: number,
    name: string,
  }
  
  export interface ICustomerAddressType {
    id: number,
    name: string,
  }

  // Shopify search result types
  export interface IShopifyCustomerAddressNode {
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    phone?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    province?: string | null;
    provinceCode?: string | null;
    zip?: string | null;
    country?: string | null;
  }

  export interface IShopifyFoundCustomer {
    id: string;
    displayName: string;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    phone?: string | null;
    verifiedEmail?: boolean | null;
    validEmailAddress?: boolean | null;
    emailMarketingState?: string | null;
    smsMarketingState?: string | null;
    addresses: IShopifyCustomerAddressNode[];
  }

  export interface ISyncCustomerRequest {
    customer_id: number;
    brand_id: number;
    shopify_order_id: number;
    shipping_address_id: number;
    billing_address_id: number;
    living_address_id: number;
  }